/* HEILMANN HOME · Anmeldelser
   Henter de aktuelle tal fra Trustpilots egen trustbox-data (samme kilde som
   deres widget, CORS-aaben) og retter tallene paa siden, hvis de har flyttet
   sig siden sidste redigering. Fejler den, bliver de gemte tal staaende —
   derfor SKAL de gemte tal vaere rigtige, naar de skrives ind.
   Cache i sessionStorage, saa der hoejst hentes én gang pr. faneblad. */
(function () {
  var TEMPLATE = '5419b6a8b0d04a076446a9ad'; /* Micro Review Count — den gratis, de har adgang til */

  function tegn(panel, d) {
    var bu = d && (d.businessUnit || d.businessEntity);
    if (!bu || !bu.numberOfReviews) return;
    var antal = bu.numberOfReviews.total;
    var score = bu.trustScore;
    if (!antal || !score) return;

    var elScore = panel.querySelector('[data-tp-score]');
    if (elScore) elScore.textContent = String(score).replace('.', ',');

    var elAntal = panel.querySelector('[data-tp-antal]');
    if (elAntal) elAntal.textContent = antal;

    var st = panel.querySelector('[data-tp-stjerner]');
    if (st) {
      st.style.setProperty('--hh-anm-pct', (score / 5) * 100 + '%');
      st.setAttribute('aria-label', String(score).replace('.', ',') + ' ud af 5 stjerner');
    }

    var n = bu.numberOfReviews;
    var kort = { 5: n.fiveStars, 4: n.fourStars, 3: n.threeStars, 2: n.twoStars, 1: n.oneStar };
    panel.querySelectorAll('[data-tp-raekke]').forEach(function (li) {
      var v = kort[li.getAttribute('data-tp-raekke')];
      if (typeof v !== 'number') return;
      var tal = li.querySelector('[data-tp-raekke-tal]');
      if (tal) tal.textContent = v;
      var bj = li.querySelector('.hh-anm__bjaelke > i');
      if (bj) bj.style.width = (v / antal) * 100 + '%';
    });
  }

  document.querySelectorAll('[data-hh-tp]').forEach(function (panel) {
    var bu = panel.getAttribute('data-hh-tp');
    if (!bu) return;
    var noegle = 'hh-tp-' + bu;

    try {
      var cached = sessionStorage.getItem(noegle);
      if (cached) { tegn(panel, JSON.parse(cached)); return; }
    } catch (e) { /* privat browsing — hent bare */ }

    fetch('https://widget.trustpilot.com/trustbox-data/' + TEMPLATE +
          '?businessUnitId=' + encodeURIComponent(bu) + '&locale=da-DK')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        try { sessionStorage.setItem(noegle, JSON.stringify(d)); } catch (e) {}
        tegn(panel, d);
      })
      .catch(function () { /* de gemte tal bliver staaende */ });
  });
})();
